export default {
  SET_PAYMENT_LIST (state, payload) {
    state.bankOptions = payload.bankOptions || []
    state.navItems = payload.navItems || []
    state.filterItems = payload.filterItems || []
    state.paymentMethods = payload.paymentMethods || []
    state.loaded = true
  }
}
